import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import HeroImage from '../components/HeroImage'
import Banner from '../components/Banner'
import MachinerySup from '../components/forms/MachinerySup'


const Machinery = () => {
    return (
        <div>
            <Navbar />
            <HeroImage heading='Machinery Suppliers Entry' text='Please complete the registration form' />
            <MachinerySup />
            <Banner />
            <Footer />
        </div>
    )
}

export default Machinery;
